/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */
import { Placeholder, PlaceholderText } from 'sarsaparilla';

export default function SummaryPlaceholder() {
    return (
        <div className="tp-summary-placeholder">
            <div className="tp-summary-placeholder-header">
                <Placeholder height="4rem" />
            </div>
            <div className="tp-summary-placeholder-body">
                <div className="tp-summary-placeholder-message">
                    <PlaceholderText fontSize={14} lineHeight={14 * 1.2} lines={1} />
                </div>
            </div>
            <div className="tp-summary-placeholder-footer">
                <div className="tp-summary-placeholder-controls">
                    <Placeholder height="4rem" />
                </div>
            </div>
        </div>
    );
}
